import { render } from "./Template2View.vue?vue&type=template&id=59b81bdd"
import script from "./Template2View.vue?vue&type=script&lang=js"
export * from "./Template2View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__